"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _emotion = require("emotion");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _reactIntl = require("react-intl");

var _react = _interopRequireWildcard(require("react"));

var _ContractOption = _interopRequireDefault(require("./ContractOption"));

var _shapes = _interopRequireDefault(require("./shapes"));

var _withI18n = _interopRequireDefault(require("../i18n/withI18n"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-bottom: 5px;\n  margin-top: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _emotion.css)(_templateObject());

var ContractSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ContractSelector, _PureComponent);

  function ContractSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContractSelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContractSelector).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      selectedContract: _this.props.selectedContract
    };
    return _this;
  }

  (0, _createClass2.default)(ContractSelector, [{
    key: "onSelect",
    value: function onSelect(selectedContract) {
      var onSelect = this.props.onSelect;
      this.setState({
        selectedContract: selectedContract
      });
      onSelect && onSelect(selectedContract);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          contracts = _this$props.contracts,
          _this$props$intl = _this$props.intl;
      _this$props$intl = _this$props$intl === void 0 ? this.props : _this$props$intl;
      var locale = _this$props$intl.locale;
      var selectedContract = this.state.selectedContract;
      var finalClassName = (0, _emotion.cx)(style, className);
      var contractOptions = contracts.map(function (contract) {
        var key = "".concat(contract.termId, "-").concat(contract.revisionId);
        var selected = selectedContract && contract.termId === selectedContract.termId && contract.revisionId === selectedContract.revisionId;
        return _react.default.createElement(_ContractOption.default, {
          key: key,
          contract: contract,
          locale: locale,
          onSelect: _this2.onSelect,
          selected: selected
        });
      });
      return _react.default.createElement("div", {
        className: finalClassName
      }, contractOptions);
    }
  }]);
  return ContractSelector;
}(_react.PureComponent);

var _default = (0, _withI18n.default)((0, _reactIntl.injectIntl)(ContractSelector));

exports.default = _default;